import React, { memo, SVGProps } from 'react'

export const Share = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.9072 4.704C18.8189 4.66752 18.7257 4.64832 18.6317 4.64832H7.39198C6.99454 4.64832 6.67198 4.97088 6.67198 5.36832C6.67198 5.76576 6.99454 6.08832 7.39198 6.08832H16.8931L4.85854 18.1229C4.57726 18.4042 4.57726 18.8602 4.85854 19.1414C4.9987 19.2816 5.18302 19.3526 5.36734 19.3526C5.55166 19.3526 5.73598 19.2826 5.87614 19.1414L17.9107 7.10688V16.608C17.9107 17.0054 18.2333 17.328 18.6307 17.328C19.0281 17.328 19.3507 17.0054 19.3507 16.608V5.36832C19.3507 5.27424 19.3315 5.18112 19.295 5.0928C19.2221 4.91712 19.0819 4.77696 18.9053 4.704H18.9072Z"
      fill="currentColor"
    />
  </svg>
))
